/**
 * 1-1. 키워드 정밀 분석 섹션
 * - PC/Mobile 검색량, 클릭수, CTR을 카드 3개로 표시
 * - report.keywordInfo 가 없으면 렌더링하지 않음
 *
 * @param {object} report  - 분석 리포트 데이터 (report.keywordInfo 사용)
 * @param {string} keyword - 현재 분석 기준 키워드 (헤더 라벨 표시용)
 */
import React from 'react';
import { Row, Col, Statistic } from 'antd';
import { AreaChartOutlined } from '@ant-design/icons';

const KeywordPrecisionSection = ({ report, keyword }) => {
    if (!report.keywordInfo) return null;

    return (
        <>
            <div className="section-title-premium" style={{ marginTop: 28 }}>
                <AreaChartOutlined /> 키워드 정밀 분석 ({keyword})
            </div>
            <div className="summary-group-box" style={{ marginBottom: 32 }}>
                <Row gutter={24} style={{ display: 'flex' }}>
                    {[
                        {
                            label: '월간 검색량',
                            total: report.keywordInfo.total,
                            pc: report.keywordInfo.pc,
                            mobile: report.keywordInfo.mobile,
                            color: '#4f46e5',
                            suffix: '건',
                        },
                        {
                            label: '월간 클릭수',
                            total: report.keywordInfo.totalClick,
                            pc: report.keywordInfo.pcClick,
                            mobile: report.keywordInfo.mobileClick,
                            color: '#10b981',
                            suffix: '회',
                        },
                        {
                            label: '월간 클릭률 (CTR)',
                            total: report.keywordInfo.totalCtr,
                            pc: report.keywordInfo.pcCtr,
                            mobile: report.keywordInfo.mobileCtr,
                            color: '#f59e0b',
                            suffix: '%',
                            precision: 2,
                        },
                    ].map((item, idx) => (
                        <Col span={8} key={idx} style={{ display: 'flex' }}>
                            <div
                                style={{
                                    background: '#fff',
                                    padding: '24px 20px',
                                    borderRadius: 16,
                                    border: '1px solid #f1f5f9',
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Statistic
                                    title={
                                        <span
                                            style={{
                                                color: '#64748b',
                                                fontWeight: 600,
                                                fontSize: 14,
                                            }}
                                        >
                                            {item.label}
                                        </span>
                                    }
                                    value={item.total}
                                    precision={item.precision}
                                    valueStyle={{
                                        color: item.color,
                                        fontWeight: 900,
                                        fontSize: 24,
                                    }}
                                    suffix={
                                        <span
                                            style={{
                                                fontSize: 14,
                                                color: '#94a3b8',
                                                fontWeight: 500,
                                            }}
                                        >
                                            {item.suffix}
                                        </span>
                                    }
                                />
                                <div style={{ marginTop: 20 }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            fontSize: 12,
                                            marginBottom: 8,
                                        }}
                                    >
                                        <span
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 4,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: '50%',
                                                    background: '#60a5fa',
                                                }}
                                            ></span>
                                            <span style={{ color: '#1e293b', fontWeight: 700 }}>
                                                PC
                                            </span>
                                            <span style={{ color: '#64748b' }}>
                                                {(item.pc || 0).toLocaleString()}
                                                {item.suffix === '%' ? '%' : ''}
                                            </span>
                                        </span>
                                        <span
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 4,
                                            }}
                                        >
                                            <span style={{ color: '#64748b' }}>
                                                {(item.mobile || 0).toLocaleString()}
                                                {item.suffix === '%' ? '%' : ''}
                                            </span>
                                            <span style={{ color: '#4f46e5', fontWeight: 700 }}>
                                                Mobile
                                            </span>
                                            <span
                                                style={{
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: '50%',
                                                    background: '#4f46e5',
                                                }}
                                            ></span>
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            height: 10,
                                            display: 'flex',
                                            borderRadius: 5,
                                            overflow: 'hidden',
                                            background: '#f1f5f9',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${(item.pc / (item.pc + item.mobile || 1)) * 100}%`,
                                                background: '#60a5fa',
                                                transition: 'width 0.5s ease-in-out',
                                            }}
                                        ></div>
                                        <div
                                            style={{
                                                width: `${(item.mobile / (item.pc + item.mobile || 1)) * 100}%`,
                                                background: '#4f46e5',
                                                transition: 'width 0.5s ease-in-out',
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </>
    );
};

export default KeywordPrecisionSection;
